import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconInsidePoint = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 1.5C3.33211 1.5 3.5 1.66789 3.5 1.875V3.375C3.5 5.65317 5.34683 7.5 7.625 7.5H9.71967L7.97335 5.75368C7.8269 5.60723 7.8269 5.3698 7.97335 5.22335C8.1198 5.0769 8.35723 5.0769 8.50368 5.22335L10.8902 7.60983C11.0366 7.75628 11.0366 7.99372 10.8902 8.14017L8.50368 10.5267C8.35723 10.6731 8.1198 10.6731 7.97335 10.5267C7.8269 10.3802 7.8269 10.1428 7.97335 9.99632L9.71967 8.25H7.625C4.93261 8.25 2.75 6.06739 2.75 3.375V1.875C2.75 1.66789 2.91789 1.5 3.125 1.5Z",
		fill: "#C0C0C0"
	})
});
export default SvgIconInsidePoint;
